import defaultMessagingService from '../MessagingService';
import AssetImportService from './AssetsImportService';

const assetImportService = new AssetImportService( {
	messagingService: defaultMessagingService
} );

export default assetImportService;
